import React from "react"
import styled from "styled-components"
import Header from "./header"
import Planner from "../../planner/container"

const Box = styled.section`
  position: relative;
  padding: 10vw 5rem 0vw 5rem;

   &:after {
    content: "";
    position: absolute;
    left: 0;
    top: 10vw;
    width: 100%;
    height: 100%;
    background-color: var(--c-blue-101);
    transform: skewY(6deg);
    z-index: -1;
  }

  .chevron-bkg {
    width: 50%;
    height: 100%;
    top: 5%;
    left: 0;
    z-index: -1;
  }

  @media (max-width: 766px) {
    padding: 0;
    padding-top: 7rem;
    padding-bottom: 2rem;
  }
`

const Ele = () => {
  return (
    <Box id="time-machine">
      <Header />
      <Planner />
    </Box>
  )
}
export default Ele
